import React from 'react';

import {
  StandardHero,
  HomeHero,
  MediaAndText,
  TextOnMedia,
  BrandHero,
  BrandCardsRow,
  OtherBrandsRow,
  ArticleHero,
  Card,
  RichText,
  HalfAndHalf,
  SpotlightOnCarousel,
  ProductRow,
  TeamCarousel,
  NewsCarousel,
  FAQBlock,
  Tabs,
  TabsLong,
  MondelezTabs,
  ListStack,
  Media,
  TeamCardRow,
  InteractiveMap,
  Timeline,
  CookiePolicy,
  Breadcrumbs,
  Share,
  Video
} from '@components';

const ComponentList = {
  'sections.standard-hero': StandardHero,
  'sections.home-hero': HomeHero,
  'sections.article-hero': ArticleHero,
  'sections.media-and-text': MediaAndText,
  'sections.text-on-media': TextOnMedia,
  'sections.brand-hero': BrandHero,
  'sections.brand-cards-row': BrandCardsRow,
  'sections.other-brands-row': OtherBrandsRow,
  'elements.brand-card': Card,
  'elements.product-card': Card,
  'elements.news-card': Card,
  'elements.team-card': Card,
  'elements.wysiwyg': RichText,
  'elements.cookie-policy': CookiePolicy,
  'elements.breadcrumbs': Breadcrumbs,
  'elements.share-block': Share,
  'sections.half-and-half': HalfAndHalf,
  'sections.spotlight-on-carousel': SpotlightOnCarousel,
  'sections.product-row': ProductRow,
  'sections.team-carousel': TeamCarousel,
  'sections.news-carousel': NewsCarousel,
  'sections.project-carousel': NewsCarousel,
  'sections.faq-block': FAQBlock,
  'sections.tabs': Tabs,
  'sections.tabs-long-form': TabsLong,
  'sections.mondelez-tabs-form': MondelezTabs,
  'sections.list-stack': ListStack,
  'sections.team-card-row': TeamCardRow,
  'sections.interactive-map': InteractiveMap,
  'sections.timeline': Timeline,
  'media.image': Media,
  'media.video': Video
};

export const createComponent = ({ id, strapiComponent, index, ...data }) => {
  const TagName = ComponentList[String(strapiComponent)];

  if (typeof TagName === `undefined`) {
    return (
      <div key={`dynamic-zone-component-${strapiComponent}-${index}`}>
        Component <b>{strapiComponent}</b> not found
      </div>
    );
  }

  return (
    <TagName
      key={`dynamic-zone-component-${strapiComponent}-${index}`}
      data={{ strapiComponent, ...data }}
    />
  );
};
